// @ts-nocheck
/* eslint-disable */

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.StyledList = void 0;

var _styledComponents = _interopRequireWildcard(require('styled-components'));

var _colors = require('../../utils/colors');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc =
            Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([
    '\n  position: relative;\n  display: block;\n  margin: 0;\n  padding: 0;\n  width: ',
    ';\n  list-style: none;\n  border-radius: ',
    ';\n  border: ',
    ';\n  overflow: hidden;\n  box-sizing: border-box;\n  background: ',
    ';\n\n  ',
    '\n'
  ]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(['\n    ', '\n  ']);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var disabledStyle = function disabledStyle(props) {
  return (0, _styledComponents.css)(_templateObject(), props.disabled && 'opacity: 0.3;');
};

var StyledList = _styledComponents.default.ul.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['width', 'disabled'].includes(prop);
  }
})(
  _templateObject2(),
  function (props) {
    return props.width;
  },
  function (props) {
    return props.theme.list.border.radius;
  },
  function (props) {
    return ''
      .concat(props.theme.list.border.width, ' ')
      .concat(props.theme.list.border.style, ' ')
      .concat((0, _colors.normaliseColor)(props.theme.list.border.color, props.theme));
  },
  function (props) {
    return (0, _colors.normaliseColor)(props.theme.list.background.color, props.theme);
  },
  function (props) {
    return props.disabled && disabledStyle(props);
  }
);

exports.StyledList = StyledList;
